import { motion, useReducedMotion } from "framer-motion";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import ChatBubble, { TypingBubble } from "./ChatBubble";
import { useTypedChat } from "./useTypedChat";
import { DEMO_SCRIPT } from "./demoScript";

export default function PhoneFrame() {
  const { t, i18n } = useTranslation("landing");
  const reduce = useReducedMotion();
  const lang = (i18n.language || "fa").split("-")[0];
  const script = DEMO_SCRIPT[lang] || DEMO_SCRIPT.fa;

  const { containerRef, visible, typing } = useTypedChat(script, {
    enabled: !reduce,
  });

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      whileHover={reduce ? {} : { rotate: 0, scale: 1.02 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className={clsx(
        "relative mx-auto w-full max-w-[320px] rounded-[42px] p-3 sm:max-w-[360px] sm:p-4",
        "bg-[#0a1018] shadow-card-lg border-2 border-white/5"
      )}
    >
      {/* Screen */}
      <div className="relative flex h-[520px] flex-col overflow-hidden rounded-[30px] bg-gradient-to-b from-canvas to-surface sm:h-[580px]">
        {/* Notch */}
        <div className="absolute left-1/2 top-2 z-20 h-5 w-24 -translate-x-1/2 rounded-full bg-[#0a1018]" />

        {/* Header */}
        <div className="flex items-center gap-3 border-b border-line bg-surface px-4 pb-3.5 pt-8">
          <div className="relative grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-gradient-to-br from-teal to-teal-2 text-[14px] font-black text-white">
            R
            <span className="absolute -bottom-0.5 -end-0.5 h-3 w-3 rounded-full border-2 border-surface bg-emerald-500" />
          </div>
          <div className="min-w-0">
            <div className="text-[14px] font-extrabold text-ink">
              {t("demo.botName")}
            </div>
            <div className="text-[11px] font-semibold text-teal-2">
              {t("demo.botStatus")}
            </div>
          </div>
        </div>

        {/* Body */}
        <div
          ref={containerRef}
          className="flex flex-1 flex-col gap-2.5 overflow-y-auto px-4 py-4"
        >
          {visible.map((msg) => (
            <ChatBubble key={msg.id} from={msg.from} text={msg.text} />
          ))}
          {typing && <TypingBubble />}
        </div>

        {/* Input */}
        <div className="flex items-center gap-2.5 border-t border-line bg-surface px-4 py-3">
          <input
            type="text"
            disabled
            placeholder={t("demo.placeholder")}
            className="flex-1 rounded-full border border-line bg-surface-2 px-4 py-2.5 text-[12.5px] text-ink-mute outline-none placeholder:text-ink-mute"
          />
          <button
            type="button"
            disabled
            className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-gradient-to-br from-teal to-teal-2 text-[15px] text-white"
          >
            ➤
          </button>
        </div>
      </div>
    </motion.div>
  );
}